import React from "react";
import HiddenDataTable from "../../../../../../components/HiddenDataTable";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../../../assets/svg/icons/common/Filter";
import Download from "../../../../../../assets/svg/icons/common/Download";
import master_card from "../../../../../../../../images/v2/master24x24.svg";
import Table from "../../../../../../components/Table";
import Pagination from "../../../../../../components/Pagination/Pagination";
import useCommonStore from "../../../../../../stores/common";

function Retrieval() {
  const expandDetails = useCommonStore((state) => state.expandDetails);

  const renderCardType = (data, row) => {
    return (
      <div className={style.cart_type_cell}>
        <img src={master_card} />
        <span>{data}</span>
      </div>
    );
  };

  const renderToRebutCell = (data, row) => {
    return <span className={style.rebut_badge}>{data} day(s)</span>;
  };

  const tableColumns = [
    {
      headerName: "office",
      field: "office",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "card",
      field: "card",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "cart type",
      field: "card_type",
      width: 150,
      allowSort: true,
      renderCell: renderCardType,
    },
    {
      headerName: "Post Date",
      field: "post_date",
      width: 150,
      allowSort: true,
    },
    {
      headerName: "Batch Date",
      field: "batch_date",
      width: 150,
      allowSort: true,
    },
    {
      headerName: "reference No.",
      field: "ref_no",
      width: 170,
      allowSort: true,
    },
    {
      headerName: "amount",
      field: "amount",
      width: 150,
      allowSort: true,
    },
    {
      headerName: "to rebut",
      field: "to_rebut",
      width: 150,
      allowSort: true,
      renderCell: renderToRebutCell,
    },
    {
      headerName: "respond",
      field: "respond",
      allowSort: true,
      width: 100,
    },
    {
      headerName: "reason",
      field: "reason",
      allowSort: true,
    },
  ];

  const data = [
    {
      office: "02343",
      card: "***7656",
      card_type: "MC",
      post_date: "10/10/2002",
      batch_date: "10/10/2002",
      ref_no: "***6656 09",
      amount: "$ 200.00",
      to_rebut: "3",
      respond: "Respond here",
      reason: "132 - Consumer - Cancelled Recurring Transaction",
    },
    {
      office: "02343",
      card: "***7656",
      card_type: "MC",
      post_date: "10/10/2002",
      batch_date: "10/10/2002",
      ref_no: "***6656 09",
      amount: "$ 200.00",
      to_rebut: "3",
      respond: "Respond here",
      reason: "132 - Consumer - Cancelled Recurring Transaction",
    },
    {
      office: "02343",
      card: "***7656",
      card_type: "MC",
      post_date: "10/10/2002",
      batch_date: "10/10/2002",
      ref_no: "***6656 09",
      amount: "$ 200.00",
      to_rebut: "3",
      respond: "Respond here",
      reason: "132 - Consumer - Cancelled Recurring Transaction",
    },
    {
      office: "02343",
      card: "***7656",
      card_type: "MC",
      post_date: "10/10/2002",
      batch_date: "10/10/2002",
      ref_no: "***6656 09",
      amount: "$ 200.00",
      to_rebut: "3",
      respond: "Respond here",
      reason: "132 - Consumer - Cancelled Recurring Transaction",
    },
    {
      office: "02343",
      card: "***7656",
      card_type: "MC",
      post_date: "10/10/2002",
      batch_date: "10/10/2002",
      ref_no: "***6656 09",
      amount: "$ 200.00",
      to_rebut: "3",
      respond: "Respond here",
      reason: "132 - Consumer - Cancelled Recurring Transaction",
    },
  ];

  return (
    <>
      {!expandDetails && (
        <div className={style.container}>
          <HiddenDataTable />
        </div>
      )}

      {expandDetails && (
        <div className={style.container}>
          <header className={style.header}>
            <div className={style.left}>
              <h5>Retrieval details</h5>
              <ButtonIcon textColor="#254FE2">Expand All</ButtonIcon>
            </div>
            <div className={style.right}>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Filter />
              </ButtonIcon>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Download />
                <span>Download</span>
              </ButtonIcon>
            </div>
          </header>

          <div className={style.body}>
            <Table columns={tableColumns} data={data} />
          </div>

          <footer className={style.footer}>
            <Pagination />
          </footer>
        </div>
      )}
    </>
  );
}

export default Retrieval;
